export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] items-center overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20comic%20manga%20illustration%20background%20of%20colorful%20floating%20pages%20books%20and%20stars%20in%20warm%20orange%20amber%20and%20teal%20tones%2C%20soft%20dreamy%20artistic%20atmosphere%2C%20abstract%20animated%20composition%2C%20no%20text%2C%20high%20detail&width=1600&height=1000&seq=cc-hero-bg&orientation=landscape"
          alt="虫虫漫画阅读平台插画背景"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-page px-4 py-24 md:px-6 md:py-28 text-center text-background-50">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs md:text-sm font-medium backdrop-blur">
          <i className="ri-sparkling-2-fill text-primary-300"></i>
          海量漫画 · 零门槛免费阅读
        </span>

        <h1 className="mt-6 font-heading text-3xl leading-tight md:text-5xl lg:text-6xl">
          免费的虫虫漫画
          <span className="mt-2 block text-primary-300">免费版入口与完整指南</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          一个专注让每个人都能轻松看漫画的免费阅读平台。了解免费版入口、功能特点及限制，
          对比与付费版的差异，体验零门槛阅读，快速上手免费版的所有便利。
        </p>

        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#entry"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-400 sm:w-auto"
          >
            <i className="ri-book-open-line"></i>
            立即开始免费阅读
          </a>
          <a
            href="#compare"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3.5 text-sm font-bold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
          >
            查看版本对比
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>

        <dl className="mx-auto mt-12 grid max-w-2xl grid-cols-3 gap-4">
          {[
            { num: "上千万", label: "话内容" },
            { num: "十大", label: "漫画分类" },
            { num: "100%", label: "免费阅读" },
          ].map((item) => (
            <div key={item.label} className="rounded-xl bg-background-50/10 px-2 py-4 backdrop-blur">
              <dt className="sr-only">{item.label}</dt>
              <dd className="font-heading text-2xl text-primary-300 md:text-3xl">{item.num}</dd>
              <dd className="mt-1 text-xs text-background-100 md:text-sm">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}